import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <Container>
        <Row className="align-items-center">
          {/* ===== Left: About Section (with social links) ===== */}
          <Col md={4} className="footer-about" data-aos="fade-right">
            <h5 className="footer-heading">About Lismount</h5>
            <p>
              With over 7+ years of excellence, Lismount is a leading manufacturer
              and exporter of premium linen fabrics — trusted by designers and
              brands across 30+ countries.
            </p>

            {/* Social Links */}
            <div className="social-links" aria-label="Lismount social media links">
              <a
                href="https://www.linkedin.com/company/lismount-tex-india-llp/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
                title="LinkedIn"
              >
                <FaLinkedin />
              </a>

              <a
                href="https://www.instagram.com/lismount_india"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram"
                title="Instagram"
              >
                <FaInstagram />
              </a>
            </div>
          </Col>

          {/* ===== Center: Quick Links ===== */}
          <Col md={4} className="footer-links" data-aos="fade-up">
            <h5 className="footer-heading">Quick Links</h5>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/product">Product</a></li>
              <li><a href="/business">Our Business</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </Col>

          {/* ===== Right: Google Map Section ===== */}
          <Col md={4} className="footer-map" data-aos="fade-left">
            <h5 className="footer-heading">Our Location</h5>
            <div className="map-container">
              <iframe
                title="linen Fabrics Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.8239981466727!2d77.42197997378112!3d11.20065445122806!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba90f002b639afd%3A0x160e26199181df0a!2sLISMOUNT%20TEX%20INDIA%20LLP!5e0!3m2!1sen!2sin!4v1763102941843!5m2!1sen!2sin"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </Col>
        </Row>

        {/* ===== Footer Bottom ===== */}
        <div className="footer-copy text-center mt-4">
          © {new Date().getFullYear()} Lismount. All Rights Reserved.
          <br />
          <span className="footer-credit">
            Designed and Developed by{" "}
            <a
              href="https://www.jeginetechnologies.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>Jegina Technologies</strong>
            </a>
          </span>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
